/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaQDEntryResponse model module.
 * @module model/AqaQDEntryResponse
 * @version v0
 */
export default class AqaQDEntryResponse {
  /**
   * Constructs a new <code>AqaQDEntryResponse</code>.
   * @alias module:model/AqaQDEntryResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaQDEntryResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaQDEntryResponse} obj Optional instance to populate.
   * @return {module:model/AqaQDEntryResponse} The populated <code>AqaQDEntryResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaQDEntryResponse();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('version'))
        obj.version = ApiClient.convertToType(data['version'], 'Number');
      if (data.hasOwnProperty('ownerId'))
        obj.ownerId = ApiClient.convertToType(data['ownerId'], 'String');
      if (data.hasOwnProperty('aqdId'))
        obj.aqdId = ApiClient.convertToType(data['aqdId'], 'String');
      if (data.hasOwnProperty('publishTimestamp'))
        obj.publishTimestamp = ApiClient.convertToType(data['publishTimestamp'], 'Number');
      if (data.hasOwnProperty('owned'))
        obj.owned = ApiClient.convertToType(data['owned'], 'Boolean');
      if (data.hasOwnProperty('howMany'))
        obj.howMany = ApiClient.convertToType(data['howMany'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaQDEntryResponse.prototype.id = undefined;

/**
 * @member {Number} timestamp
 */
AqaQDEntryResponse.prototype.timestamp = undefined;

/**
 * @member {String} title
 */
AqaQDEntryResponse.prototype.title = undefined;

/**
 * @member {String} description
 */
AqaQDEntryResponse.prototype.description = undefined;

/**
 * @member {Number} version
 */
AqaQDEntryResponse.prototype.version = undefined;

/**
 * @member {String} ownerId
 */
AqaQDEntryResponse.prototype.ownerId = undefined;

/**
 * @member {String} aqdId
 */
AqaQDEntryResponse.prototype.aqdId = undefined;

/**
 * @member {Number} publishTimestamp
 */
AqaQDEntryResponse.prototype.publishTimestamp = undefined;

/**
 * @member {Boolean} owned
 */
AqaQDEntryResponse.prototype.owned = undefined;

/**
 * @member {Number} howMany
 */
AqaQDEntryResponse.prototype.howMany = undefined;

